/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Nav_LabelInputs */

const en_billing_nav_label = /** @type {(inputs: Billing_Nav_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platform plan`)
};

const pl_billing_nav_label = /** @type {(inputs: Billing_Nav_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonament`)
};

/**
* | output |
* | --- |
* | "Platform plan" |
*
* @param {Billing_Nav_LabelInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const billing_nav_label = /** @type {((inputs?: Billing_Nav_LabelInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Nav_LabelInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_billing_nav_label(inputs)
	return en_billing_nav_label(inputs)
});